module.exports = __webpack_public_path__ + "static/img/limitedTime@2x.386f45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/limitedTime@2x.png
// module id = LwBa
// module chunks = 1